import React, { PropsWithChildren } from "react"
import { AspectRatio, AspectRatioProps, Box } from "@chakra-ui/react"

import useVideo from "@hooks/useVideo"

export interface VideoPosterRatioProps extends PropsWithChildren {
  aspectRatioProps?: AspectRatioProps
}

const VideoPosterRatio = ({ aspectRatioProps, children }: VideoPosterRatioProps) => {
  const { video } = useVideo()

  return video.poster ? (
    <Box pos="relative" w="full" maxW="980px" maxH="570px">
      <AspectRatio ratio={98 / 57} w="full" {...aspectRatioProps}>
        {children}
      </AspectRatio>
    </Box>
  ) : (
    <></>
  )
}

export default VideoPosterRatio
